import { CYCLIC_EXAMS, StudentServicePath } from "utils/constants";
import RecyclingIcon from "@mui/icons-material/Recycling";
import permissions from "app/permissions";

import ListCyclicExams from "./List";
import { tenants } from "utils/tenants";
import CreateCyclicExams from "./Create";
import EditCyclicExams from "./Edit";
import ShowCyclicExam from "./Show/Show";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <RecyclingIcon />,
  name: StudentServicePath + CYCLIC_EXAMS,
  title: "Циклични изпити",
  list: <ListCyclicExams />,
  create: <CreateCyclicExams />,
  createPermission: permissions.canManageCyclicExams,
  edit: <EditCyclicExams />,
  editPermission: permissions.canManageCyclicExams,
  show: <ShowCyclicExam />,
  showPermission: permissions.canPreviewCyclicExams,
  permission: permissions.canPreviewCyclicExams,
};
